export const radii = {
  none: "0",
  sm: "4px",
  md: "8px",
  lg: "16px",
  pill: "9999px",
  full: "50%"
};



// WEBPACK FOOTER //
// ./src/design-system/theme/radii.js